import PropTypes from "prop-types";
import DatePicker from 'react-date-picker';

const FieldDate = ({
                       id,
                       iconBefore,
                       iconAfter,
                       wrapperClasses,
                       inputClasses,
                       field,
                       form: {touched, errors}
                   }) => {
    return (
        <div className={"mb-6 " + wrapperClasses}>
            <div className="field input-group flex py-2 mb-2 shadow">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                   {iconBefore}
                </span>
                }
                <DatePicker
                    {...field}
                    format={"dd-MM-yyyy"}
                    className={"w-full  py-2 px-3 text-gray-700 leading-tight focus:outline-none bg-white focus:shadow-outline " + inputClasses}
                />
                {iconAfter &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                    {iconAfter}
                </span>
                }
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldDate;

FieldDate.propTypes = {
    id: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
}
